import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeService from "../../../Services/HomeService";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import HttpClientXml from "../../../utils/HttpClientXml";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function ManageCity() {
    const userRole = localStorage.getItem("role");
    const userCity = localStorage.getItem("city");
    const loggedUserID = localStorage.getItem("uid");
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cityID, setCityID] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState({ name: "", image: "" });


    const columns = [
        { name: "S.No.", selector: (row) => row.sln, sortable: true },
        {
            name: "ID",
            cell: (row) => (
                <>
                    <span title="Click to copy" onClick={() => handleCopy(row.id)}
                        style={{ cursor: "pointer" }}
                    >
                        {row.id}
                    </span>
                </>
            ),
        },
        { name: "City Name", selector: (row) => row.name, sortable: true },
        {
            name: "Image",
            cell: (row) => (
                <img
                    src={row.image || 'placeholder-image-url'}
                    alt={row.name}
                    width="50"
                    height="50"
                />
            ),
        },
        {
            name: "Action",
            cell: (row) => (
                <>
                    <span title="Edit" onClick={() => handleEdit(row)}>
                        <i
                            className="fa-solid fa-pen-to-square"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "rgb(133, 218, 79)",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                    <span title="Delete" onClick={() => handleDelete(row.id)}>
                        <i
                            className="fa-solid fa-trash-can text-danger"
                            style={{
                                cursor: "pointer",
                                padding: "5px",
                                marginRight: "5px",
                                fontSize: "1.5em",
                                color: "#477DA5",
                                backgroundColor: "#E9F3F7",
                            }}
                        ></i>
                    </span>
                </>
            ),
        },
    ];

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.success("City ID Copied")
            })
            .catch((err) => console.error("Error copying text: ", err));
    };

    const fetchAllCities = async () => {
        setLoading(true);
        try {
            const res = await HomeService.getCities();
            const arr = res?.data
                .map((ele, ind) => ({
                    sln: ind + 1,
                    name: ele.name,
                    image: ele.image,
                    id: ele._id,
                }));
            setCities(arr)
            if (userCity) {
                setCities(arr.filter(item => item.id === userCity));
            }

        } catch (error) {
            console.error("Error fetching cities:", error);
            toast.error("Failed to load cities!");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllCities();
    }, []);

    const handleEdit = (row) => {
        setIsEdit(true);
        setEditData({ name: row.name, image: row.image });
        setCityID(row.id);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete City?",
            text: "Are you sure you want to delete this city?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            confirmButtonColor: "#d33",
            cancelButtonText: "Cancel",
            reverseButtons: true,
        });
        if (result.isConfirmed) {
            try {
                await HomeService.deleteCity(id);
                Swal.fire("Deleted!", "City has been deleted.", "success");
                fetchAllCities();
            } catch (error) {
                Swal.fire("Error!", "Failed to delete city.", "error");
            }
        }
    };

    const handleImageUpload = async (e) => {
        const data = new FormData();
        data.append("image", e.target.files[0]);
        try {
            const res = await HttpClientXml.fileUplode("image-upload", "POST", data);

            setEditData({ ...editData, image: res.image });
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = { name: editData.name, image: editData.image };
            if (isEdit) {
                await HomeService.updateCity(cityID, data);
                toast.success("City updated successfully!");
            }
            setIsEdit(false);
            setEditData({ name: "", image: "" });
            fetchAllCities();
        } catch (error) {
            toast.error("Failed to save city.");
            console.error("Error saving city:", error);
        }
    };

    return (
        <>
            <div className="main_wrap" style={{ marginTop: "6rem" }}>
                <div className="container-fluid">
                    {isEdit && (
                        <section className="chartBox_area">
                            <h2>Edit City</h2>
                            <hr />
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="cityName">
                                            City Name<span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="cityName"
                                            className="form-control"
                                            value={editData.name}
                                            onChange={(e) =>
                                                setEditData({ ...editData, name: e.target.value })
                                            }
                                            placeholder="Enter City Name"
                                        />
                                    </div>

                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="inputGroupFile04">Upload New Image</label>
                                        <input
                                            type="file"
                                            id="inputGroupFile04"
                                            className="form-control"
                                            onChange={handleImageUpload}
                                        />
                                    </div>

                                    {editData.image && (
                                        <div className="col-md-6 mt-3">
                                            <label htmlFor="cityImage">City Image</label>
                                            <div>
                                                <img
                                                    src={editData.image}
                                                    alt="City"
                                                    width="100"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <button type="submit" className="btn btn-primary mt-3">
                                    Save Changes
                                </button>
                            </form>
                        </section>
                    )}

                    <div className="mt-5">
                        <div style={headLineStyle} className="page-headline">
                            Manage Cities
                        </div>
                        {loading ? (
                            <p>Loading...</p>
                        ) : (
                            <DataTable
                                columns={columns}
                                data={cities}
                                pagination
                                responsive
                                highlightOnHover
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManageCity;
